import { useAppContext } from 'src/context/store/app-provider';
import { Locale } from 'src/types/lang-locale-type';
import { getLocale } from 'src/utils/get-locale';
import { isValidDate } from 'src/utils/is-valid-date';

export const useNextBillingDate = () => {
  const {
    lang,
    offers: { monthlyBilling },
  } = useAppContext();

  if (!monthlyBilling?.available || !monthlyBilling.paymentDate) return null;

  const billingDate = new Date(monthlyBilling.paymentDate);

  if (!isValidDate(billingDate)) return null;

  const day = billingDate.toLocaleString(Locale['en-US'], { day: 'numeric' });
  const month = billingDate.toLocaleString(getLocale(lang), {
    month: 'short',
  });

  return { day, month };
};
